<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        <el-button type="danger" @click="delRows">删除</el-button>
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" width="80">
          <template slot-scope="{ row }">
            <el-button type="text" @click="edit(row)">编辑</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
  </div>
</template>
<script>
import curdMixins from '@/mixins/trend/curd'
import list from '@/components/personnel/result/salary/list'
// import editDialog from '@/components/personnel/result/salary/editDialog'

export default {
  name: 'salary',
  mixins: [curdMixins],
  components: {
    list,
    // editDialog
  },
  data() {
    return {
      select: {
        Id: null,
        Code: '',
        Name: ''
      }
    }
  },
  mounted() {
  },
  methods: {
    onImport() {
      this.$refs.importDialog.open()
    },
    onExport() {
      this.$confirm('是否导出数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$refs.list.onExport()
        })
        .catch(() => {})
    },
    onSelect(data) {
      console.log('onSelect', data)
      this.select.DpId = data.DpId
      this.select.DpName = data.DpName
      this.select.EmpId = data.EmpId
      this.select.EmpName = data.EmpName
      this.$refs.list.getData({ IdChain: data.IdChain })
      // this.reload();
    },
    titleClick() {
      this.select.Id = null
      this.select.Code = ''
      this.select.Name = ''
      this.$refs.list.getData({ IdChain: null })
    },
    create() {
      this.$router.push({ name: 'editSalary', params: { mode: 'create' } })
    },
    edit(data) {
      this.$router.push({ name: 'editSalary', params: { mode: "edit", data } })
    },
    details(data) {
      this.$router.push({
        name: "editSalary",
        params: { mode: "details", data },
      });
    },
    // create() {
    //   this.$refs.editDialog.openCreate({
    //     Pid: this.select.Id,
    //     Pcode: this.select.Code,
    //     Pname: this.select.Name
    //   })
    // },
    delRows() {
      let rows = this.$refs.list.getCheckedRows()
      if (rows.length == 0) {
        this.$message.warning('请选择要删除的数据')
        return
      }
      this.$confirm('确认删除所选的数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let ids = rows.map(item => {
            return item.SalaryId
          })
          this.$refs.list.delRange(ids)
        })
        .catch(() => {})
    }
  }
}
</script>